import { Component, Prop, Vue } from 'vue-property-decorator'
import { escape } from 'lodash'
import { hyperlink, handlebars } from '@/utils'
import { i18n } from '@/i18n'

@Component
export default class extends Vue {
  @Prop({ type: String, default: '' })
  text!: string

  @Prop({ type: String, default: '' })
  fontSize!: string

  @Prop({ type: [String, Number], default: '' })
  fontWeight!: string | number

  @Prop({ type: String, default: '' })
  color!: string

  @Prop({
    type: String,
    default: 'left',
    validator: value => ['left', 'center', 'right'].includes(value)
  })
  align!: string

  get computedTextStyles () {
    return {
      fontSize: this.fontSize,
      fontWeight: this.fontWeight,
      textAlign: this.align,
      color: this.color,
    }
  }

  /**
   * Text is passed through the handlebars parser.
   */
  get computedText () {
    const context = this.$store.getters['context/getContext']
    return handlebars(i18n.t(this.text) as any, context)
  }

  /**
   * Escapes html characters in text.
   */
  get escapedText () {
    return escape(this.computedText)
  }

  /**
   * Converts all markup in text to html tags.
   *
   * @returns {String} Returns a safe html string.
   */
  get computedHtml () {
    // Escape all characters before converting to html
    return hyperlink(this.escapedText)
  }
}
